import { useNavigate } from "react-router-dom";
import { useClientRecordMessages } from "@/lib/clientRecordQueries";

export default function MessagesTab({ workspaceId, memberId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = useClientRecordMessages(workspaceId, memberId);

  return (
    <div data-testid="client-360-messages-tab">
      <div className="flex justify-end mb-3">
        <button
          onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/messages`)}
          className="text-xs text-terracotta hover:underline"
          data-testid="client-360-messages-open-full-page"
        >
          Open full Messages workbench →
        </button>
      </div>
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-messages-loading">Loading threads…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="client-360-messages-error">Couldn't load threads.</p>
      ) : data.items.length === 0 ? (
        <p className="text-sm text-ink-soft" data-testid="client-360-messages-empty">No message threads yet.</p>
      ) : (
        <div className="space-y-2" data-testid="client-360-messages-list">
          {data.items.map((t) => (
            <div key={t.thread_id} className="border border-ink/10 rounded-lg p-3 bg-white/50" data-testid={`client-360-thread-${t.thread_id}`}>
              <p className="text-xs text-ink-soft uppercase">{t.visibility_scope.replace("_", " ")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
